<template>
  <component :is="pageComponent" />
</template>

<script>
import PcIndex from "@/views/pc/index/index.vue";
import MobileIndex from "@/views/mobile/index.vue";
import { isMobile } from "@/utils/device";

export default {
  name: "HomeBridge",
  computed: {
    pageComponent() {
      return isMobile() ? MobileIndex : PcIndex;
    },
  },
};
</script>
